module.exports = __webpack_public_path__ + "img/ZJ5132.08973d92.png";